export default "__VITE_ASSET__BGeQnLsH__"